import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Location } from '@angular/common';

import { Observable } from 'rxjs';

import { Department } from 'src/app/models/find-university-papers-result';
import { GoToPaperDetailParams, UniversityDetails, Year } from '../../../models/search-univ-interfaces';
import { ExamType } from '../../../models/university-search-condition';

export interface ExamTypeSection {
  examType: ExamType;
  label: string;
  departments: Department[];
}

@Component({
  selector: 'app-search-univ-detail-base',
  templateUrl: './search-univ-detail-base.component.html',
  styleUrls: ['./search-univ-detail-base.component.scss']
})
export class SearchUnivDetailBaseComponent implements OnInit, OnChanges {
  @Input() isBToC: boolean;
  @Input() universityDetails$: Observable<UniversityDetails>;
  @Input() searchResults: Department[];
  @Input() years: Year[];
  @Input() selectedYear: string;
  @Input() isPremiumIconShown: boolean;
  @Input() isBookmarked: boolean;
  @Input() universityId: string;
  @Input() buttonAbled$: Observable<boolean>;
  @Input() errorUnivId$: Observable<string>;

  @Output() yearsChangeClick = new EventEmitter<string>();
  @Output() goToPaperDetailClick = new EventEmitter<GoToPaperDetailParams>();
  @Output() addUniversityBookmarkClick = new EventEmitter<string>();
  @Output() deleteUniversityBookmarkClick = new EventEmitter<string>();

  sections: ExamTypeSection[] = [];

  private readonly sectionDefinitions: Array<{ examType: ExamType; label: string }> = [
    { examType: ExamType.GENERAL, label: '一般入試' },
    { examType: ExamType.SPECIAL_ADMISSIONS, label: '推薦・総合・その他の入試' }
  ];

  constructor(private location: Location) {}

  yearFormControl = new UntypedFormControl();

  ngOnInit() {
    this.yearFormControl.setValue(this.selectedYear);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.searchResults) {
      this.editSections();
    }
  }

  trackBySectionExamType(_index: number, section: ExamTypeSection): ExamType {
    return section.examType;
  }

  trackByDepartmentName(_index: number, dept: Department): string {
    return dept.deptName;
  }

  goBack() {
    this.location.back();
  }

  onYearsChange() {
    this.yearsChangeClick.emit(this.yearFormControl.value);
    this.selectedYear = this.yearFormControl.value;
  }

  private editSections() {
    const departments = this.searchResults || [];
    this.sections = this.sectionDefinitions
      .map(def => ({
        examType: def.examType,
        label: def.label,
        departments: this.filterDepartmentsByExamType(departments, def.examType)
      }))
      .filter(section => section.departments.length > 0);
  }

  // 入試方式で papers を絞り込んで学部一覧を返す。該当 papers が無い学部は除外する
  private filterDepartmentsByExamType(departments: Department[], examType: ExamType): Department[] {
    return departments
      .map(department => ({
        ...department,
        papers: department.papers.filter(paper => paper.examType === examType)
      }))
      .filter(department => department.papers.length > 0);
  }
}
